const knowledgeApi = {
  knowledge: {
    list: '/api/knowbase',
  },
};

export default knowledgeApi;

export const knowledgeApiConfig = knowledgeApi.knowledge;
